import type { CodeProps } from "@hightouch/formkit";
import type { SharedProps } from ".";
import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { CodeSnippet } from "@hightouch/htui";

export const FKCode = ({
  name,
  title,
  content,
  query,
}: CodeProps & SharedProps) => {
  const code = useMemo(
    () => (query.enabled ? (query.data ?? []) : content),
    [query, content],
  );
  return (
    <Controller
      name={name}
      render={() => <CodeSnippet code={code.join("\n")} label={title} />}
    />
  );
};
